/**
 * CMS Testimonial Model
 */
export class Testimonial {
  constructor(
    public title: string,
    public quote: string,
    public author: string,
    public icon: string,
    public icon_name: string,
    public job_title: string,
    public company: string,
    public view: string,
    public external_url?: string,
    public external_link_cta?: string
  ) {}
}
